import SessionTimeoutInfo from "@/models/session-timeout-info";
import { differenceInSeconds } from "date-fns";
import DataService from "@/services/data-service/data-service";

export default class UserSessionTimeoutService {
  private readonly _totalElapsedTime: number = parseInt(process.env.VUE_APP_TIMEOUT ?? "600");
  private _elapsedTime = this._totalElapsedTime;
  private _interval: number | undefined;
  private _refreshTokenInterval: number | undefined;

  constructor(private _dataService: DataService) {}

  get elapsedTime() {
    return this._elapsedTime;
  }

  get totalElapsedTime() {
    return this._totalElapsedTime;
  }

  start() {
    if (this._interval) return;
    this._interval = window.setInterval(() => {
      this._elapsedTime--;
      document.dispatchEvent(
        new CustomEvent("sessionTimeOut", {
          detail: new SessionTimeoutInfo(this._elapsedTime, this._totalElapsedTime)
        })
      );
      if (this._elapsedTime % 120 === 0)
        console.info(`Elapsed Time to Logout: ${this._elapsedTime} secs`);

      if (this._elapsedTime <= 0) {
        this.logout();
      }
    }, 1000);
    //refresh token interval
    this._refreshTokenInterval = window.setInterval(async () => {
      if (this._dataService.getters.isOffline() || this._refreshTokenInterval == undefined) return;
      const userInfo = this._dataService.actions.Auth.getUserInfo();
      if (!userInfo) {
        this.logout();
        return;
      }
      const refreshDate = new Date(userInfo.expires);
      const diffSecs = differenceInSeconds(refreshDate, new Date());
      if (diffSecs > 60) return;

      const refreshToken = userInfo?.refreshToken ?? null;
      if (!refreshToken) {
        this.logout();
        return;
      }
      const { data } = await this._dataService.actions.Auth.refreshToken(refreshToken);
      if (data) {
        this._dataService.actions.Auth.putUserInfo(data);
      }
    }, 10000);
  }

  stop(refreshStop = true) {
    clearInterval(this._interval);
    this._interval = undefined;
    if (refreshStop) {
      clearInterval(this._refreshTokenInterval);
      this._refreshTokenInterval = undefined;
    }
  }
  logout() {
    document.dispatchEvent(new Event("logOut"));
  }

  reset() {
    this._elapsedTime = this._totalElapsedTime;
  }
}
